export default "__VITE_ASSET__DxDY2gxR__"